import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  SONAR_V3_ALPHA_CREATE_SESSION,
  SONAR_V3_CREATE_SESSION,
  SONAR_V3_POLL,
  SONAR_V3_POLL_ALPHA,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isSonarV3ErrorPayload } from '@web-platform/shared-universal-utils-frontend/src/helpers/isSonarErrorPayload';
import keyBy from 'lodash/keyBy';

import { isEmptyItinerary, isNullishItinerary } from '../utils';

import { mapSonarV3Segments } from './sonarV3SegmentsMapper';

import type {
  MutationAction,
  QueryAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SegmentStateBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/segmentsBookingPanel';

export const INITIAL_STATE: SegmentStateBookingPanel = {
  byId: {},
};

const segmentsReducer = (
  state: SegmentStateBookingPanel = INITIAL_STATE,
  action: MutationAction | QueryAction,
): SegmentStateBookingPanel => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      if (
        action.payload.type === SONAR_V3_CREATE_SESSION ||
        action.payload.type === SONAR_V3_ALPHA_CREATE_SESSION ||
        action.payload.type === SONAR_V3_POLL ||
        action.payload.type === SONAR_V3_POLL_ALPHA
      ) {
        if (isSonarV3ErrorPayload(action.payload.response)) {
          return state;
        }
        if (
          isEmptyItinerary(action.payload.response) ||
          isNullishItinerary(action.payload.response)
        ) {
          return state;
        }

        return {
          byId: {
            ...state.byId,
            ...keyBy(
              mapSonarV3Segments(action.payload.response.body.itinerary?.legs),
              (segment) => segment.id,
            ),
          },
        };
      }

      return state;
    }

    default:
      return state;
  }
};

export default segmentsReducer;
